import React, { Component } from 'react';
import { Col, Row, Modal } from 'react-materialize';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions/index';
import CompatabilityIndicator from './CompatabilityIndicator';
import Answer from './Answer';

class Speaker extends Component {
	constructor(props) {
		super(props);

		this.state = {
			enumeratedDevices: [],
			availableDevices: [],
			enumeratedDevicesPermissionNeeded: false,
			messages: {
				pending: 'Select your speaker and click the test button',
				fail: 'Sorry, based on your computer, you are unable to participate in this study',
				success: 'Audio check passed!',
			},
			audioUrl:
				'https://pilotly-public.s3.amazonaws.com/audio/speaker-tech-check.mp3',
			speakerAnswers: [
				{ text: 'The cow jumped over the moon.', isCorrect: false },
				{ text: 'Bahh bahh black sheep.', isCorrect: false },
				{ text: 'The mouse ran up the clock.', isCorrect: false },
				{ text: 'Jack and Jill ran up the hill.', isCorrect: true },
				{ text: 'Pop goes the weasel.', isCorrect: false },
				{ text: 'None of the above.', isCorrect: false },
				{ text: 'Could not hear', isCorrect: false },
			],
		};

		this.selectAnswer = this.selectAnswer.bind(this);
	}

	componentDidMount() {
		this.enumerateDevicesWithPermission();

		// TODO: `forceAutoPlay` should be called passing the function to Modal options.onOpenStart
		// as described in the docs https://react-materialize.github.io/react-materialize/?path=/story/javascript-modal--default
		// but the function isn't being called when passed on options object, probably because the library is outdated and not matching the current documentation
		// the code below is a workaround
		const trigger = document.querySelector('#test-speaker-trigger');
		trigger.onclick = this.forceAutoPlay;
	}

	forceAutoPlay() {
		const audio = document.querySelector('#tech-check-audio');
		audio.currentTime = 0;
		audio.play();
	}

	setupAvailableDeviceNames() {
		let availableDevices = [];
		this.state.enumeratedDevices.forEach((device) => {
			if (!device.label) {
				this.setState({ enumeratedDevicesPermissionNeeded: true });
				availableDevices.push({
					name: 'Audio Input ' + (availableDevices.length + 1),
					device: device,
				});
			} else {
				availableDevices.push({ name: device.label, device });
			}
		});
		this.setState({ availableDevices });
	}

	enumerateDevices() {
		navigator.mediaDevices
			.enumerateDevices()
			.then((devices) => {
				const uniqueOutputDevices = devices
					.filter((device) => device.kind === 'audiooutput')
					.reduce((array, current) => {
						const groupIds = array.map((item) => item.groupId);
						if (groupIds.indexOf(current.groupId) === -1) array.push(current);
						return array;
					}, []);
				this.setState(
					{ enumeratedDevices: uniqueOutputDevices },
					this.setupAvailableDeviceNames
				);
			})
			.catch((error) => {
				console.error(error);
				this.props.onFail('Speaker');
				this.setState({
					enumeratedDevices: [
						...this.state.enumeratedDevices,
						{
							id: '-',
							kind: 'error',
							deviceId: 'error',
						},
					],
				});
			});
	}

	enumerateDevicesWithPermission() {
		navigator.mediaDevices
			.getUserMedia({ audio: true, deviceId: 'default' })
			.then(() => {
				this.enumerateDevices();
			})
			.catch((error) => {
				console.error(error);
				this.props.onFail('Speaker');
			});
	}

	handleChange(event) {
		const speakerId = event.target.value;
		const audio = document.querySelector('#tech-check-audio');
		if (speakerId) audio.setSinkId(speakerId);
	}

	selectAnswer(answer) {
		if (!answer.isCorrect) this.props.onFail('Speaker');
		this.props.setTechCheckSpeakerTestAnswer(answer);
	}

	render() {
		return (
			<div>
				<div className="dp-instructions tech-check-test-title">
					Select Speaker
				</div>
				<Row>
					<Col s={12} m={6}>
						<select
							className="tech-check-input-field"
							onChange={this.handleChange}
						>
							{this.state.availableDevices.map(({ name, device }) => (
								<option key={device.deviceId} value={device.deviceId}>
									{name}
								</option>
							))}
						</select>
					</Col>
					<Col s={12} m={6}>
						<CompatabilityIndicator
							state={this.props.speaker}
							messages={this.state.messages}
						/>
					</Col>
				</Row>
				<Row>
					<Modal
						id="test-speaker-modal"
						open={false}
						trigger={<button id="test-speaker-trigger">Test Speaker</button>}
					>
						<div className="modal-column bg-white answers">
							<h4>What is the message in the audio?</h4>
							<audio id="tech-check-audio" controls controlsList="nodownload">
								<source src={this.state.audioUrl} />
							</audio>
							<div className="test-speaker-answers">
								{this.state.speakerAnswers.map((answer, index) => (
									<Answer
										key={answer.text}
										answer={answer}
										index={index}
										callback={this.selectAnswer}
										givenAnswer={this.props.speakerAnswer}
									/>
								))}
							</div>
						</div>
					</Modal>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	speakerAnswer: state.techCheck.speakerAnswer,
	speaker: state.techCheck.speaker,
});

export default connect(mapStateToProps, actions)(Speaker);



// WEBPACK FOOTER //
// ./src/components/tech-check/Speaker.js